import React from 'react';
import { useHistory } from 'react-router-dom';
import { ArrowBack } from '@insurancemenu/imenu-components-lib/dist/icons';
import { BackButtonStyled, SubtitleStyled, HeaderStyled, TextWrapperStyled, TitleStyled } from './styles';
import {
  PAGE_HEADER_BACK_BTN_TEST_ID,
  PAGE_HEADER_CAPTION_TEST_ID,
  PAGE_HEADER_TEST_ID,
  PAGE_HEADER_TITLE_TEST_ID,
} from '../constants';

/**
 * HeaderSpacing type that defines the spacing configuration for the page header.
 *
 * 'DEFAULT' - A layout where the title and subtitle are followed directly by the content.
 *
 * 'WITH_ACTION_BELOW' - A layout where the title and subtitle are followed by an action block
 * (such as button, dropdown, etc.), which is placed closer to the header to keep the spacing tight.
 */
export type HeaderSpacing = 'DEFAULT' | 'WITH_ACTION_BELOW';

interface Props {
  title: string;
  subtitle?: React.ReactNode;
  showBackButton?: boolean;
  onRedirect?: () => void;
  disableBackButton?: boolean;
  subtitleMaxWidth?: string;
  spacing?: HeaderSpacing;
  className?: string;
}

/** @deprecated: use PageHeader from the components library instead */
const PageHeader: React.FC<Props> = ({
  title,
  subtitle,
  onRedirect,
  showBackButton = true,
  disableBackButton = false,
  subtitleMaxWidth,
  spacing = 'DEFAULT',
  className,
}) => {
  const history = useHistory();

  const onBackButtonClick = (): void => {
    history.goBack();
  };

  return (
    <HeaderStyled data-test-id={PAGE_HEADER_TEST_ID} $spacing={spacing} className={className}>
      {showBackButton && (
        <BackButtonStyled
          leftIconProp={<ArrowBack />}
          type="text"
          size="medium"
          onClick={onRedirect || onBackButtonClick}
          data-test-id={PAGE_HEADER_BACK_BTN_TEST_ID}
          disabled={disableBackButton}
        >
          Back
        </BackButtonStyled>
      )}
      <TextWrapperStyled>
        <TitleStyled data-test-id={PAGE_HEADER_TITLE_TEST_ID}>{title}</TitleStyled>
        <SubtitleStyled $maxWidth={subtitleMaxWidth} data-test-id={PAGE_HEADER_CAPTION_TEST_ID}>
          {subtitle}
        </SubtitleStyled>
      </TextWrapperStyled>
    </HeaderStyled>
  );
};

export default PageHeader;
